import { render, staticRenderFns } from "./ChannelRuleEdit.vue?vue&type=template&id=fad321a2&scoped=true&"
import script from "./ChannelRuleEdit.vue?vue&type=script&lang=ts&"
export * from "./ChannelRuleEdit.vue?vue&type=script&lang=ts&"
import style0 from "./ChannelRuleEdit.vue?vue&type=style&index=0&id=fad321a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad321a2",
  null
  
)

export default component.exports